import type * as yup from "yup";
export * from './address';
export * from './baseParams';
export * from './generalParams';
export * from './individualDiscounts';
export * from './person';
export * from './property/PropertyAddressValidationSchema';
export * from './property/PropertyDataValidationSchema';
export * from './property/PropertyHouseholdValidationSchema';
export * from './property/PropertyRealtyValidationSchema';
export * from './property/PropertyValidationSchema';
export * from './travel/TravelAddonValidationSchema';
export * from './travel/TravelValidationSchema';
export * from './vehicle';

export function customNullable<T extends yup.AnySchema>(arg: T): T {
    return arg
        .transform((value, originalValue) => {
            if (originalValue === '' || originalValue === null)
                return undefined

            const parsed = Number(originalValue)
            return isNaN(parsed) ? undefined : parsed
        })
        .nullable()
}